import { createContext, useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import constantsValues, { defautlChainId } from "../constants/constantsValues";
import { useMetaMask } from "../Hooks/useMetamask";

export const AuthContext = createContext();
export const AuthContextProvider = ({ children }) => {
  const [chainToConnect, setChainToConnect] = useState(null);
  const { account, chainId, switchNetwork, walletProvider } = useMetaMask();

  useEffect(() => {
    if (chainToConnect && constantsValues[chainToConnect] === undefined) return;
    switchNetwork(chainToConnect);
  }, [chainToConnect, switchNetwork]);

  return (
    <AuthContext.Provider
      value={{
        address: account,
        provider: walletProvider?.provider,
        chainId,
        chainToConnect: chainId || defautlChainId,
        setChainToConnect,
        chainNotSupport: constantsValues[chainId] === undefined,
      }}
    >
      {children}
      <ToastContainer />
    </AuthContext.Provider>
  );
};
